import { render, staticRenderFns } from "./MalattieInfettiveArchivioList.vue?vue&type=template&id=ccfab6ce"
import script from "./MalattieInfettiveArchivioList.vue?vue&type=script&lang=js"
export * from "./MalattieInfettiveArchivioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports